module.exports = __webpack_public_path__ + "static/bass_cn-5497890518fbdbb17129470505c97287.pdf";